import { Model, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  status: belongsTo('graphql/room-status'),
  utilization: belongsTo('graphql/room-utilization'),

  calendarId: attr('string'),
  displayName: attr('string'),
  capacity: attr('number'),
  amenities: attr('string'),
  imageUrl: attr('string'),
  claimable: attr('boolean'),
  maskMeetingNames: attr('string'),
  timeToBookInMinutes: attr('number'),
  checkInEnabled: attr('boolean'),
});
